import React from 'react';
import Form from 'react-bootstrap/Form';
import * as yup from 'yup';
import _ from 'lodash'

import InputWidget from './InputWidget';

class IntegerInputWidget extends InputWidget {
    render() {
        return (
            <Form.Group>
                <Form.Label>{this.renderLabelText()}</Form.Label>
                <Form.Control type="number"
                              name={this.getFieldName()}
                              value={this.getValue()}
                              isInvalid={this.isInvalid()}
                              onChange={this.handleChange}
                              onBlur={this.handleBlur}
                              disabled={this.props.disabled}
                />
                <Form.Control.Feedback type="invalid">
                    {this.getError()}
                </Form.Control.Feedback>
                {this.getCustomRequiredError()}
            </Form.Group>
        );
    }

    handleChange(event) {
        if (event.target.value === '') {
            this.props.formikProps.setFieldValue(this.getFieldName(), null);
        } else {
            super.handleChange(event);
        }
    }
}

export function type() {
    return 'integer';
}

export function initialValue(widget) {
    return null;
}

/**
 * @param widget
 * @param allowPartialSubmissions
 * @returns {NumberSchema<number | undefined | null, object>}
 */
export function schema(widget, allowPartialSubmissions) {
    let schema = yup.number().nullable()
        .min(_.isNumber(widget.minValue) ? widget.minValue : Number.MIN_SAFE_INTEGER)
        .max(_.isNumber(widget.maxValue) ? widget.maxValue : Number.MAX_SAFE_INTEGER);

    if (!allowPartialSubmissions && widget.required) {
        schema = schema.required();
    }

    return schema;
}

export function component() {
    return IntegerInputWidget;
}
